import { render } from "./ExportInvoices.vue?vue&type=template&id=bc3df4ea"
import script from "./ExportInvoices.vue?vue&type=script&lang=js"
export * from "./ExportInvoices.vue?vue&type=script&lang=js"

import "./ExportInvoices.vue?vue&type=style&index=0&id=bc3df4ea&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__